module.exports = __webpack_public_path__ + "img/news-image-review7.eb802e08.png";